<template>
    <div class="apply">
      <apply-container></apply-container>
    </div>
</template>
<script>
import ApplyContainer from '@/components/apply/Container.vue'
export default {
  name: 'apply',
  components: {
    ApplyContainer
  }
}
</script>
<style lang="stylus">
.apply
  height 100%
</style>
